import { ShoppingCart } from 'lucide-react'
import { Button } from '@/components/ui'
import { useAppDispatch, useAppSelector } from '@/store/hooks'
import { toggleCart, selectCartItems, selectCartTotals } from '@/store/cartSlice'
import { formatPrice } from '@/utils/formatting'

export function FloatingCartButton() {
  const dispatch = useAppDispatch()
  const items = useAppSelector(selectCartItems)
  const totals = useAppSelector(selectCartTotals)

  const totalItems = items.reduce((sum, item) => sum + item.quantity, 0)

  if (items.length === 0) return null

  return (
    <Button
      onClick={() => dispatch(toggleCart())}
      className="fixed bottom-4 left-1/2 -translate-x-1/2 sm:bottom-6 sm:left-auto sm:right-6 sm:translate-x-0 z-30 shadow-xl hover:shadow-2xl h-14 px-6 text-base gap-2.5 animate-in slide-in-from-bottom duration-300 bg-primary text-primary-foreground hover:bg-primary/90 active:scale-95 transition-all rounded-full"
    >
      <ShoppingCart className="h-5 w-5" />
      <span className="font-semibold">
        View Cart ({totalItems})
      </span>
      <span className="font-semibold">
        &middot; {formatPrice(totals.total, items[0]?.menuItem?.currency)}
      </span>
    </Button>
  )
}
